import { ReactElement } from 'react'

import { Tooltip } from 'antd'
import isNull from 'lodash/isNull'

import { UNDEFINED_VALUE } from 'const/formatting'
import { LabelPageTabId } from 'routing/pageTabIds'
import { colors } from 'styles/colors'
import { Label } from 'types'

import { LabelElement, LabelGroup } from './Label'

interface LabelsProps {
    labels: Label[] | null
    empty?: string
    linkToTab?: LabelPageTabId
}

const Labels = ({
    labels = [],
    empty = UNDEFINED_VALUE,
    linkToTab,
}: LabelsProps): ReactElement => {
    const renderEmpty = (): ReactElement => (
        <div style={{ textAlign: 'center', color: colors.textMuted }}>
            {empty}
        </div>
    )

    const renderSingleLabel = (label: Label): ReactElement => (
        <Tooltip key={label.id} title={label.description || label.name}>
            <LabelElement label={label} linkToTab={linkToTab} />
        </Tooltip>
    )

    if (isNull(labels)) {
        return renderEmpty()
    }

    switch (labels.length) {
        case 0:
            return renderEmpty()
        case 1:
            return renderSingleLabel(labels[0])
        default:
            return <LabelGroup labels={labels} linkToTab={linkToTab} />
    }
}

export default Labels
